export const capitalizeFullName = (name) => {
  if (!name || typeof name !== 'string') return '';
  
  return name
    .toLowerCase()
    .split(' ')
    .map(word => {
      if (word.length === 0) return word;
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
};

export const capitalizeNames = (firstName, lastName) => {
  const formattedFirstName = capitalizeFullName(firstName);
  const formattedLastName = capitalizeFullName(lastName);
  
  return {
    firstName: formattedFirstName,
    lastName: formattedLastName,
    fullName: `${formattedFirstName} ${formattedLastName}`.trim()
  };
};

export const capitalizeName = (name) => {
  return capitalizeFullName(name);
};